import styled, { createGlobalStyle } from "styled-components";

export const SettingsDialogGlobalStyles = createGlobalStyle`
  .settings-dialog {
    width: min(360px, calc(100vw - 1rem));
  }

  .settings-dialog .p-dialog-header {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  .settings-dialog .p-dialog-content {
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const SettingsButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.treeNodeHover};
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s,
    border-color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.iconHover};
    box-shadow: ${({ theme }) => theme.shadow.medium};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: 1.5rem 0 0.25rem;
`;

export const SettingRow = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`;
